const publishedAt = '2026-07-13T23:51:38+09:00';
const category = '1233회 로또 가이드';
const siteUrl = 'https://mongpick.com';

const topics = [
  {
    id: 102,
    slug: '1233회-로또-예상번호-총정리',
    title: '1233회 로또 예상번호 총정리',
    keyword: '1233회 로또 예상번호',
    excerpt: '1233회 추첨 전 예상번호를 고를 때 확인할 일정, 조합 기준과 안전한 활용법을 한 번에 정리합니다.',
    image: '{{image-102}}',
    imageAlt: '1233회 로또 예상번호를 달력과 번호 공으로 정리한 설명형 일러스트',
    sections: [
      ['1233회 일정과 예상번호의 의미', '1233회 로또 6/45는 2026년 7월 18일 추첨 예정이며 공식 결과는 아직 공개 전입니다. 따라서 지금 확인하는 숫자는 당첨을 보장하는 답이 아니라 구매 전 선택을 돕는 참고 조합입니다. 회차와 추첨일을 먼저 확인하고, 같은 번호를 과도하게 반복하기보다 여러 기준을 차분히 비교하면 예상번호 콘텐츠를 더 건전하게 활용할 수 있습니다.'],
      ['한 게임보다 여러 조합 비교하기', '숫자 여섯 개만 보고 좋고 나쁨을 단정하기보다 3~5개 조합을 나란히 놓고 홀짝, 구간, 연속수와 합계를 확인해 보세요. 서로 다른 조합을 비교하면 특정 숫자대에 몰린 경우를 쉽게 발견할 수 있습니다. 다만 균형이 당첨 가능성을 높인다는 뜻은 아니며, 선택 과정을 정리하는 체크리스트로만 활용하는 태도가 중요합니다.'],
      ['예산 안에서 번호 생성기 활용하기', '직접 고른 숫자 두세 개를 남기고 나머지를 무작위로 채우면 개인적인 의미와 자동 선택의 편리함을 함께 살릴 수 있습니다. 생성 결과가 마음에 들지 않으면 다시 만들되, 구매 횟수와 금액은 미리 정한 범위를 넘기지 마세요. 몽픽 생성기는 후보를 빠르게 비교하는 도구이며 실제 추첨 결과를 예측하거나 보장하지 않습니다.']
    ],
    table: [['확인 항목', '권장 점검'], ['추첨 일정', '2026년 7월 18일 예정'], ['조합 수', '3~5개를 비교'], ['활용 원칙', '참고용·예산 준수']],
    ordered: ['회차와 추첨 예정일을 확인합니다.', '마음에 둔 숫자와 자동 숫자를 섞습니다.', '홀짝·구간·합계를 한 번씩 점검합니다.'],
    bullets: ['예상번호는 당첨번호가 아닙니다.', '모든 조합의 1등 확률은 동일합니다.', '구매는 정한 예산 안에서만 진행합니다.'],
    conclusion: '1233회 로또 예상번호는 정답을 찾는 일이 아니라 내가 납득할 수 있는 선택 과정을 만드는 데 의미가 있습니다. 일정 확인, 여러 조합 비교, 간단한 균형 점검을 거치면 충동적으로 숫자를 바꾸는 일을 줄일 수 있습니다. 생성기는 아이디어를 얻는 보조 도구로 이용하고 결과는 공식 발표 후 확인하세요. 무엇보다 로또는 생활의 부담이 아닌 가벼운 즐거움 안에서 이용하는 것이 바람직합니다.',
    faq: [['1233회 당첨번호가 공개됐나요?', '아닙니다. 1233회는 2026년 7월 18일 추첨 예정이므로 현재 숫자는 참고용 예상 조합입니다.'], ['예상번호를 몇 게임 만들면 좋나요?', '정답은 없지만 비교 목적이라면 3~5개 정도로 시작하고 반드시 개인 예산 안에서 이용하세요.']]
  },
  {
    id: 103,
    slug: '1233회-로또-자동번호-뽑는-법',
    title: '1233회 로또 자동번호 뽑는 법',
    keyword: '1233회 로또 자동번호',
    excerpt: '수동 선택이 어렵다면 자동번호 생성 원리와 중복 확인 순서를 익혀 1233회 조합을 간편하게 만들어 보세요.',
    image: '{{image-103}}',
    imageAlt: '자동 생성 버튼과 여섯 개 로또 공을 표현한 설명형 일러스트',
    sections: [
      ['자동번호는 어떻게 만들어질까', '자동번호는 1부터 45까지의 숫자 중 서로 겹치지 않는 여섯 개를 무작위로 고르는 방식입니다. 특정 과거 회차나 인기 숫자를 우선하지 않기 때문에 선택 고민을 줄이는 데 유용합니다. 자동이라고 해서 더 유리하거나 불리한 것은 아니며, 가능한 모든 여섯 숫자 조합은 추첨 전에 같은 확률을 갖는다는 점을 기억해야 합니다.'],
      ['생성 결과를 확인하는 순서', '번호를 만든 뒤에는 여섯 숫자가 모두 다른지, 1~45 범위에 있는지부터 확인합니다. 다음으로 홀짝이나 저·고 구간이 한쪽에 몰렸는지를 살펴볼 수 있지만 이는 오류 검사가 아니라 취향에 따른 비교입니다. 결과를 계속 바꾸다 보면 선택 피로가 커질 수 있으므로 재생성 횟수를 미리 정해 두는 것도 실용적인 방법입니다.'],
      ['수동 숫자와 자동 숫자 섞기', '생일이나 꿈에서 본 숫자를 한두 개 유지하고 나머지를 자동으로 채우는 반자동 방식도 가능합니다. 의미 있는 숫자를 모두 넣으면 1~31에 몰릴 수 있으니 32~45 구간이 비었는지 확인해 보세요. 완성된 조합은 메모하거나 화면을 저장해 비교하되, 생성 결과를 당첨 예측이나 확률 상승 근거로 해석해서는 안 됩니다.']
    ],
    table: [['방식', '특징'], ['완전 자동', '여섯 숫자를 모두 무작위 생성'], ['반자동', '고정 숫자와 무작위 숫자 결합'], ['수동', '여섯 숫자를 직접 선택']],
    ordered: ['자동 생성 버튼을 눌러 조합을 만듭니다.', '범위와 중복 여부를 확인합니다.', '정한 횟수 안에서 최종 조합을 고릅니다.'],
    bullets: ['자동과 수동의 당첨 확률은 같습니다.', '재생성 횟수를 미리 정하면 편합니다.', '결과는 참고용으로만 보관합니다.'],
    conclusion: '1233회 자동번호는 복잡한 분석 없이 여섯 숫자를 빠르게 구성하고 싶은 사람에게 잘 맞습니다. 완전 자동, 반자동, 수동 가운데 편한 방식을 선택하고 생성 후에는 숫자 범위와 중복만 확실히 확인하세요. 홀짝이나 구간 분포는 취향을 정리하는 기준일 뿐 당첨을 보장하지 않습니다. 선택 시간을 줄이고 정한 예산을 지키는 데 생성기를 활용하면 보다 부담 없이 로또를 즐길 수 있습니다.',
    faq: [['자동번호가 수동번호보다 잘 당첨되나요?', '아닙니다. 자동과 수동은 선택 방식만 다르며 완성된 모든 조합의 당첨 확률은 같습니다.'], ['원하는 숫자를 넣고 자동 생성할 수 있나요?', '서비스가 고정 숫자를 지원하면 반자동으로 구성할 수 있고, 아니면 생성 결과에서 원하는 조합을 비교하면 됩니다.']]
  },
  {
    id: 104,
    slug: '1233회-로또-홀짝비율-구성법',
    title: '1233회 로또 홀짝비율 구성법',
    keyword: '1233회 로또 홀짝비율',
    excerpt: '1233회 번호를 점검할 때 홀수와 짝수 개수를 세는 법과 비율을 과신하지 않는 활용 원칙을 안내합니다.',
    image: '{{image-104}}',
    imageAlt: '홀수와 짝수 로또 공을 양쪽 저울로 비교한 설명형 일러스트',
    sections: [
      ['홀짝비율을 보는 이유', '홀짝비율은 여섯 숫자 중 홀수와 짝수가 각각 몇 개인지 나타냅니다. 3대3, 4대2, 2대4처럼 간단히 적으면 여러 조합을 빠르게 비교할 수 있어 번호가 한쪽 성격에 몰렸는지 눈으로 확인하기 좋습니다. 그러나 과거에 자주 보인 비율이 다음 회차에도 이어진다는 보장은 없으며, 홀짝비율은 예측 공식이 아니라 조합을 정리하는 분류 기준입니다.'],
      ['내 조합의 비율 계산하기', '각 숫자를 2로 나눴을 때 나머지가 1이면 홀수, 0이면 짝수입니다. 예를 들어 3, 8, 17, 24, 31, 42는 홀수 세 개와 짝수 세 개로 3대3입니다. 계산이 번거롭다면 숫자 아래에 홀·짝 표시를 붙여 세어 보세요. 같은 비율이라도 실제 숫자 조합은 매우 다양하므로 비율만으로 조합의 품질을 평가하지 않는 것이 중요합니다.'],
      ['극단적인 비율도 가능한가', '홀수 여섯 개나 짝수 여섯 개로만 이뤄진 조합도 규칙상 유효하며 당첨 가능성이 사라지는 것은 아닙니다. 다만 본인이 다양한 형태를 비교하고 싶다면 3대3 또는 4대2처럼 다른 비율의 조합을 함께 만들어 볼 수 있습니다. 비율을 억지로 맞추느라 마음에 둔 숫자를 계속 바꾸기보다는 선택 기준 하나로만 가볍게 활용하세요.']
    ],
    table: [['홀짝 구성', '표기 예'], ['홀수 3·짝수 3', '3:3'], ['홀수 4·짝수 2', '4:2'], ['홀수 2·짝수 4', '2:4']],
    ordered: ['여섯 숫자를 홀수와 짝수로 나눕니다.', '각 개수를 세어 비율로 적습니다.', '다른 조합과 비교하되 결과를 단정하지 않습니다.'],
    bullets: ['0:6과 6:0도 유효한 조합입니다.', '빈도는 미래 결과의 보장이 아닙니다.', '비율은 조합 정리용으로만 사용합니다.'],
    conclusion: '홀짝비율은 1233회 조합을 복잡한 계산 없이 살펴보는 가장 쉬운 방법 중 하나입니다. 숫자를 홀수와 짝수로 나누고 개수만 세면 서로 다른 조합의 모양을 금방 비교할 수 있습니다. 다만 균형 잡힌 비율이 더 높은 당첨 확률을 의미하지 않으며 극단적인 비율도 유효합니다. 여러 기준 중 하나로만 참고하고, 선택이 길어질 때는 생성기로 새 조합을 만든 뒤 간단히 점검해 보세요.',
    faq: [['홀짝 3대3이 가장 좋은가요?', '가장 보기 익숙한 구성일 수 있지만 당첨을 보장하거나 다른 비율보다 유리한 것은 아닙니다.'], ['홀수만 여섯 개 골라도 되나요?', '가능합니다. 1~45에서 중복 없이 여섯 개를 골랐다면 유효한 조합입니다.']]
  },
  {
    id: 105,
    slug: '1233회-로또-번호구간-분산법',
    title: '1233회 로또 번호구간 분산법',
    keyword: '1233회 로또 번호구간',
    excerpt: '1~45를 저번호와 고번호 또는 세 구간으로 나눠 1233회 조합의 숫자 분포를 점검하는 방법입니다.',
    image: '{{image-105}}',
    imageAlt: '1부터 45까지 로또 번호 구간을 세 블록으로 나눈 설명형 일러스트',
    sections: [
      ['번호 구간을 나누는 방법', '로또 번호 구간은 편의에 따라 1~15, 16~30, 31~45의 세 구간으로 나누거나 1~22와 23~45의 저·고 구간으로 볼 수 있습니다. 정해진 공식은 없으므로 한 가지 기준을 선택해 끝까지 동일하게 적용하는 것이 좋습니다. 구간을 나누면 여섯 숫자가 어느 범위에 모였는지 쉽게 보이지만, 고르게 퍼진 조합이 더 잘 당첨된다는 의미는 아닙니다.'],
      ['한 구간에 몰렸을 때 점검법', '여섯 숫자 중 다섯 개 이상이 같은 구간에 있다면 먼저 숫자를 잘못 입력하지 않았는지 확인합니다. 입력이 맞고 본인이 그 구성을 선호한다면 그대로 사용할 수 있습니다. 분산된 모양을 원할 때만 다른 구간 숫자 한두 개를 바꾸거나 새 조합을 생성하세요. 당첨 확률을 높이기 위한 필수 수정이 아니라 선택 폭을 넓히기 위한 취향 조정입니다.'],
      ['생일번호 편중과 고번호 보완', '생일과 기념일을 중심으로 고르면 숫자가 1~31에 머물기 쉽고 32~45가 빠질 수 있습니다. 이런 편중이 싫다면 의미 있는 숫자 두세 개는 유지하고 나머지를 자동 생성해 고번호가 섞인 후보도 비교해 보세요. 개인적인 의미를 살리면서 범위를 넓힐 수 있지만, 고번호 포함 여부 역시 미래 추첨 결과를 예측하는 근거는 아니라는 점을 기억해야 합니다.']
    ],
    table: [['구분법', '범위'], ['3구간 저', '1~15'], ['3구간 중', '16~30'], ['3구간 고', '31~45']],
    ordered: ['사용할 구간 기준을 정합니다.', '각 숫자가 속한 구간을 표시합니다.', '편중이 싫을 때만 후보를 바꿉니다.'],
    bullets: ['구간 기준은 임의로 정할 수 있습니다.', '분산은 당첨 확률을 높이지 않습니다.', '생일 숫자는 고번호와 섞어볼 수 있습니다.'],
    conclusion: '번호구간 분산법은 1233회 조합이 어느 숫자대에 집중됐는지 빠르게 확인하는 정리 도구입니다. 세 구간이나 저·고 구간 중 이해하기 쉬운 방식을 고르고 모든 후보에 같은 기준을 적용하세요. 한쪽에 몰린 조합도 유효하므로 반드시 수정할 필요는 없습니다. 다만 다양한 모양을 비교하고 싶다면 의미 있는 숫자를 일부 유지한 채 자동 생성 숫자를 더해 보세요. 최종 선택은 예산과 취향 안에서 결정하면 됩니다.',
    faq: [['저번호와 고번호의 기준은 무엇인가요?', '공식 기준은 없으며 보통 1~22와 23~45 또는 1~15, 16~30, 31~45로 나눠 봅니다.'], ['모든 구간에서 숫자를 골라야 하나요?', '아닙니다. 구간 분산은 비교 기준일 뿐 모든 구간을 반드시 포함해야 하는 규칙은 없습니다.']]
  },
  {
    id: 106,
    slug: '1233회-로또-연속번호-활용법',
    title: '1233회 로또 연속번호 활용법',
    keyword: '1233회 로또 연속번호',
    excerpt: '12와 13처럼 이어지는 숫자를 조합에 넣을 때 확인할 점과 연속수를 자연스럽게 다루는 방법을 설명합니다.',
    image: '{{image-106}}',
    imageAlt: '서로 이어진 로또 번호 공과 연결선을 표현한 설명형 일러스트',
    sections: [
      ['연속번호는 무엇인가', '연속번호는 12와 13, 또는 27과 28처럼 값이 1 차이 나는 숫자 쌍을 말합니다. 세 숫자가 이어지면 12·13·14 같은 연속 세 수가 됩니다. 보기에는 특별해 보여도 모두 1~45 안의 정상적인 숫자 조합이며 자동 생성에서도 나올 수 있습니다. 연속번호가 있다는 이유만으로 제외하거나 반대로 반드시 넣어야 한다고 판단할 근거는 없습니다.'],
      ['연속수를 넣을 때 확인할 점', '원하는 연속수 한 쌍을 고른 뒤 나머지 네 숫자가 같은 구간에 과도하게 몰렸는지, 중복 숫자가 없는지 확인하세요. 연속수 자체보다 전체 여섯 숫자를 함께 보는 것이 편합니다. 두 쌍 이상의 연속번호가 마음에 들지 않는다면 하나만 남기고 다시 생성할 수 있지만, 이는 조합의 모양을 다듬는 취향 선택이며 확률 개선 방법은 아닙니다.'],
      ['연속번호를 억지로 피하지 않기', '사람은 무작위 결과에서도 일정한 간격을 기대해 21과 22 같은 숫자가 붙으면 이상하다고 느끼기 쉽습니다. 하지만 무작위 추첨에서는 붙은 숫자도 자연스럽게 등장할 수 있습니다. 자동 생성 결과에 연속수가 포함됐다는 이유로 계속 버리면 오히려 선택 기준이 불필요하게 복잡해집니다. 마음에 드는지 여부만 확인하고 과도한 의미 부여는 피하세요.']
    ],
    table: [['형태', '예시'], ['연속 한 쌍', '12·13'], ['연속 세 수', '27·28·29'], ['두 연속 쌍', '8·9와 34·35']],
    ordered: ['연속된 숫자 쌍을 표시합니다.', '전체 조합의 중복과 범위를 확인합니다.', '취향에 맞으면 유지하고 아니면 재생성합니다.'],
    bullets: ['연속번호도 정상적인 무작위 결과입니다.', '반드시 넣거나 뺄 필요가 없습니다.', '전체 조합을 함께 비교해야 합니다.'],
    conclusion: '1233회 조합에 연속번호가 들어 있어도 걱정할 필요는 없습니다. 숫자가 붙어 있다는 사실은 조합이 잘못됐다는 신호가 아니며, 연속수를 피한다고 당첨 확률이 높아지지도 않습니다. 원하는 연속수 한 쌍을 직접 넣거나 자동 생성 결과를 그대로 활용할 수 있습니다. 중복과 범위만 확인한 뒤 전체 모양이 마음에 드는지 살펴보세요. 간단한 기준을 유지할수록 번호 선택 과정도 더 편안해집니다.',
    faq: [['연속번호가 나오면 다시 뽑아야 하나요?', '그럴 필요가 없습니다. 연속번호가 포함된 조합도 정상적이고 유효합니다.'], ['연속번호는 몇 개까지 넣을 수 있나요?', '규칙상 제한은 없지만 중복 없이 1~45의 여섯 숫자라는 기본 조건은 지켜야 합니다.']]
  },
  {
    id: 107,
    slug: '1233회-로또-끝수중복-점검법',
    title: '1233회 로또 끝수중복 점검법',
    keyword: '1233회 로또 끝수중복',
    excerpt: '3, 13, 23처럼 마지막 숫자가 같은 끝수중복을 찾고 1233회 조합 비교에 활용하는 방법입니다.',
    image: '{{image-107}}',
    imageAlt: '같은 끝자리 숫자를 색으로 묶은 로또 설명형 일러스트',
    sections: [
      ['끝수중복의 뜻과 찾는 법', '끝수는 숫자의 마지막 자리입니다. 3, 13, 23, 33, 43은 모두 끝수 3으로 묶이며, 한 조합에 같은 끝수가 두 개 이상 있으면 끝수중복이라고 부릅니다. 각 숫자의 일의 자리만 적어 보면 쉽게 확인할 수 있습니다. 끝수중복은 번호 모양을 분류하는 방법일 뿐이며, 같은 끝자리가 많다고 해서 유리하거나 불리하다고 단정할 수 없습니다.'],
      ['끝수가 겹치는 조합 비교하기', '예를 들어 4, 11, 14, 27, 34, 42에는 끝수 4가 세 번 나타납니다. 이 구성이 눈에 걸린다면 끝수가 다른 후보와 비교해 볼 수 있지만 꼭 바꿀 필요는 없습니다. 10, 20, 30, 40은 끝수 0으로 계산합니다. 숫자 자체가 중복된 것과 끝수만 같은 것은 전혀 다르므로, 먼저 실제 숫자가 모두 다른지 확인해야 합니다.'],
      ['끝수 기준을 과신하지 않기', '과거 회차에서 특정 끝수가 자주 보였더라도 다음 회차에 다시 나올지 알 수 없습니다. 끝수 하나를 정해 관련 숫자를 여러 개 넣거나 모든 끝수를 다르게 맞추는 방식은 개인 취향으로만 활용하세요. 생성 결과를 끝수 때문에 계속 버리기보다는 홀짝과 구간 등 다른 기준과 함께 한 번만 점검하고 최종 조합을 정하는 편이 효율적입니다.']
    ],
    table: [['숫자', '끝수'], ['3·13·23·33·43', '3'], ['7·17·27·37', '7'], ['10·20·30·40', '0']],
    ordered: ['각 숫자의 마지막 자리를 적습니다.', '같은 끝수가 몇 번 나오는지 셉니다.', '다른 조합과 비교하되 단정하지 않습니다.'],
    bullets: ['끝수중복과 숫자중복은 다릅니다.', '끝수 0도 하나의 그룹입니다.', '끝수 빈도는 예측 근거가 아닙니다.'],
    conclusion: '끝수중복 점검은 1233회 번호의 마지막 자리를 묶어 조합의 특징을 살펴보는 간단한 방법입니다. 실제 숫자 중복을 먼저 확인하고, 그다음 일의 자리가 같은 숫자가 몇 개인지 세어 보세요. 같은 끝수가 여러 개 있어도 조합은 유효하며 반드시 고칠 이유는 없습니다. 끝수는 홀짝이나 구간처럼 후보를 비교하는 보조 기준으로만 활용하고, 결과를 예측하는 공식으로 받아들이지 않는 것이 중요합니다.',
    faq: [['끝수가 같은 번호를 함께 골라도 되나요?', '네. 3과 13처럼 끝수만 같은 숫자는 서로 다른 숫자이므로 함께 선택할 수 있습니다.'], ['끝수중복은 몇 개가 적당한가요?', '정해진 적정 개수는 없습니다. 선호하는 모양을 비교하는 참고 기준으로만 보세요.']]
  },
  {
    id: 108,
    slug: '1233회-로또-번호합계-확인법',
    title: '1233회 로또 번호합계 확인법',
    keyword: '1233회 로또 번호합계',
    excerpt: '여섯 숫자를 더한 합계로 1233회 후보 조합을 비교하고 합계 범위를 과신하지 않는 방법을 알려드립니다.',
    image: '{{image-108}}',
    imageAlt: '로또 공 여섯 개와 계산기 합계 막대를 표현한 설명형 일러스트',
    sections: [
      ['번호합계는 어떻게 계산하나', '번호합계는 한 게임의 여섯 숫자를 모두 더한 값입니다. 예를 들어 3, 8, 17, 24, 31, 42의 합은 125입니다. 계산기를 이용하거나 작은 숫자부터 차례로 더하면 쉽게 확인할 수 있습니다. 합계는 서로 다른 조합을 하나의 숫자로 요약해 비교하는 데 편리하지만, 특정 합계 범위가 다음 당첨번호를 알려주는 예측 공식은 아닙니다.'],
      ['합계가 낮거나 높을 때', '작은 숫자가 많이 포함되면 합계가 낮아지고 큰 숫자가 많으면 합계가 높아지는 것은 자연스럽습니다. 합계가 극단적으로 보이면 입력 오류가 없는지 다시 확인하고, 본인이 다양한 구간을 원할 때만 숫자를 조정하세요. 낮거나 높은 합계도 규칙상 유효하므로 과거 평균에 맞추기 위해 마음에 든 숫자를 억지로 바꿀 필요는 없습니다.'],
      ['합계와 다른 기준 함께 보기', '합계가 같아도 실제 조합은 크게 다를 수 있습니다. 예를 들어 저번호와 고번호가 섞인 조합과 중간 구간에 몰린 조합이 우연히 같은 합계를 가질 수 있습니다. 따라서 합계만 보지 말고 홀짝, 구간, 연속수 여부를 함께 살펴보되 점검 항목을 너무 늘리지는 마세요. 숫자 선택을 정리하는 간단한 요약값으로 쓰는 것이 가장 안전합니다.']
    ],
    table: [['예시 조합', '합계'], ['3·8·17·24·31·42', '125'], ['1·5·9·14·20·26', '75'], ['21·28·32·37·41·45', '204']],
    ordered: ['여섯 숫자를 작은 수부터 적습니다.', '모든 숫자를 빠짐없이 더합니다.', '다른 조합의 합계와 참고용으로 비교합니다.'],
    bullets: ['합계가 같아도 조합은 다릅니다.', '특정 합계가 당첨을 보장하지 않습니다.', '극단값도 유효한 조합일 수 있습니다.'],
    conclusion: '번호합계는 1233회 후보 여섯 숫자를 하나의 값으로 요약해 비교하는 편리한 도구입니다. 계산 결과가 낮거나 높다면 숫자 입력을 다시 확인하고, 조합의 구간 분포가 본인 취향에 맞는지만 살펴보세요. 과거 당첨번호의 평균 합계에 맞춘다고 미래 결과를 예측할 수 있는 것은 아닙니다. 합계는 한 번만 확인하는 보조 기준으로 두고, 최종 선택은 무리 없는 예산과 편안한 기준 안에서 마무리하세요.',
    faq: [['로또 번호합계가 몇이면 좋은가요?', '정해진 좋은 합계는 없습니다. 합계는 후보 조합을 비교하는 요약값일 뿐입니다.'], ['합계가 너무 낮으면 다시 뽑아야 하나요?', '필수는 아닙니다. 입력이 정확하고 마음에 든다면 낮은 합계 조합도 사용할 수 있습니다.']]
  },
  {
    id: 109,
    slug: '1232회-당첨번호-이월수-분석',
    title: '1232회 당첨번호 이월수 분석',
    keyword: '1232회 당첨번호 이월수',
    excerpt: '1232회 결과와 1233회 후보의 겹치는 숫자를 이월수 관점에서 비교하되 예측으로 오해하지 않도록 정리합니다.',
    image: '{{image-109}}',
    imageAlt: '1232회에서 1233회로 이동하는 숫자 공과 화살표 설명형 일러스트',
    sections: [
      ['이월수는 무엇을 뜻하나', '이월수는 직전 회차 당첨번호 가운데 다음 회차 조합에도 다시 포함된 숫자를 뜻하는 표현입니다. 1232회 공식 결과와 내가 만든 1233회 후보를 나란히 놓고 같은 숫자를 표시하면 확인할 수 있습니다. 다만 1233회는 아직 추첨 전이므로 현재는 후보와의 중복만 비교할 수 있으며 실제 이월수는 결과 발표 후에야 확정됩니다.'],
      ['직전 회차와 후보 비교하기', '먼저 동행복권 공식 페이지에서 1232회 당첨번호를 확인한 뒤 메모합니다. 다음으로 생성한 1233회 후보의 각 숫자를 하나씩 대조하고 겹치는 숫자에 표시하세요. 중복이 마음에 들면 유지하고 싫다면 새로 생성할 수 있지만, 직전에 나왔다는 사실만으로 다음 회차 출현 가능성이 높아지거나 낮아진다고 단정할 수는 없습니다.'],
      ['이월수 해석에서 피할 표현', '지난주에 나왔으니 이번에는 절대 나오지 않는다거나, 이월수를 반드시 한 개 넣어야 한다는 말은 근거가 없습니다. 각 추첨은 독립적으로 진행되므로 과거 결과는 참고 기록일 뿐입니다. 이월수 분석은 후보를 비교하는 흥미로운 관점으로만 활용하고, 공식 결과를 잘못 인용하지 않도록 회차와 출처를 함께 확인하는 습관이 중요합니다.']
    ],
    table: [['점검 단계', '내용'], ['공식 결과 확인', '1232회 번호를 정확히 기록'], ['후보 대조', '1233회 후보와 같은 숫자 표시'], ['해석 원칙', '중복은 참고용으로만 판단']],
    ordered: ['1232회 공식 당첨번호를 확인합니다.', '1233회 후보와 숫자를 하나씩 대조합니다.', '겹침 여부만 기록하고 미래 결과는 단정하지 않습니다.'],
    bullets: ['실제 이월수는 1233회 추첨 후 확정됩니다.', '직전 출현은 다음 결과의 보장이 아닙니다.', '공식 회차와 출처를 반드시 확인합니다.'],
    conclusion: '1232회 당첨번호와 1233회 후보의 중복을 보는 일은 조합을 비교하는 하나의 방법입니다. 같은 숫자가 있거나 없어도 그것만으로 다음 결과를 예측할 수는 없습니다. 공식 결과를 정확히 기록하고 후보와 차분히 대조한 뒤, 마음에 들지 않을 때만 새 조합을 만들어 보세요. 1233회 실제 이월수는 2026년 7월 18일 추첨 결과가 발표된 뒤 확인해야 하며 현재 모든 예상은 참고용입니다.',
    faq: [['1233회 이월수는 지금 알 수 있나요?', '아닙니다. 1233회 추첨 전에는 실제 이월수를 확정할 수 없고 후보와의 중복만 볼 수 있습니다.'], ['직전 당첨번호는 빼는 게 좋은가요?', '그럴 근거는 없습니다. 각 추첨은 독립적이므로 포함하거나 제외하는 것은 개인 선택입니다.']]
  },
  {
    id: 110,
    slug: '1233회-로또-생일번호-편중-해법',
    title: '1233회 로또 생일번호 편중 해법',
    keyword: '1233회 로또 생일번호',
    excerpt: '생일과 기념일 숫자가 1~31에 몰릴 때 32~45 고번호를 자연스럽게 섞어 후보를 넓히는 방법입니다.',
    image: '{{image-110}}',
    imageAlt: '달력 숫자와 32부터 45까지 고번호 공을 연결한 설명형 일러스트',
    sections: [
      ['생일번호가 1~31에 몰리는 이유', '생일의 날짜는 1일부터 31일까지이므로 가족 생일과 기념일만으로 여섯 숫자를 만들면 자연스럽게 32~45가 빠집니다. 의미 있는 숫자를 쓰는 재미는 크지만 후보 범위가 달력 숫자에 집중될 수 있습니다. 이런 편중이 잘못된 것은 아니며, 더 넓은 범위를 원할 때만 고번호를 섞는 방식으로 조정하면 됩니다.'],
      ['의미 있는 숫자 일부만 남기기', '가장 기억에 남는 생일이나 기념일 숫자 두세 개를 먼저 고정하고 나머지는 자동 생성해 보세요. 자동 결과에 같은 숫자가 나오면 중복을 제거하고 다시 채웁니다. 월과 일을 붙여 714처럼 45를 넘는 숫자가 되면 7과 14로 나누는 등 일관된 규칙을 미리 정하면 숫자를 억지로 해석하는 일을 줄일 수 있습니다.'],
      ['고번호를 자연스럽게 섞는 방법', '32~45에서 반드시 몇 개를 골라야 한다는 규칙은 없습니다. 다만 생일번호 편중을 줄이고 싶다면 자동 생성 결과 중 고번호가 한두 개 포함된 조합도 함께 비교해 보세요. 개인적인 의미가 담긴 숫자와 무작위 숫자를 결합하면 선택 범위가 넓어집니다. 그렇더라도 특정 구간을 넣는 것이 당첨 확률을 높인다는 뜻은 아닙니다.']
    ],
    table: [['구성 예', '방법'], ['의미 숫자 2개', '생일·기념일에서 선택'], ['자동 숫자 4개', '1~45에서 중복 없이 생성'], ['고번호 확인', '32~45 포함 여부 비교']],
    ordered: ['의미 있는 날짜 숫자를 두세 개 고릅니다.', '나머지 자리를 자동 숫자로 채웁니다.', '중복과 32~45 포함 여부를 확인합니다.'],
    bullets: ['생일번호만 써도 유효합니다.', '고번호 포함은 의무가 아닙니다.', '날짜 변환 규칙은 미리 정합니다.'],
    conclusion: '생일번호는 나만의 이야기가 담겨 있어 번호 선택을 더 즐겁게 만들지만 1~31에 집중되기 쉽습니다. 편중이 마음에 걸린다면 의미 있는 숫자 일부를 유지하고 나머지를 자동 생성해 32~45까지 후보를 넓혀 보세요. 고번호가 반드시 필요하거나 더 유리한 것은 아니므로 억지로 넣을 필요는 없습니다. 숫자에 담긴 의미와 무작위 선택의 편리함을 적절히 섞고, 구매는 정한 예산 안에서 가볍게 즐기세요.',
    faq: [['생일번호만으로 여섯 개를 골라도 되나요?', '네. 1~45 범위에서 중복이 없다면 유효하지만 숫자가 1~31에 모일 수 있습니다.'], ['32~45 숫자는 반드시 넣어야 하나요?', '아닙니다. 범위를 넓혀 보고 싶을 때 비교용으로 넣을 수 있을 뿐 필수 규칙은 아닙니다.']]
  },
  {
    id: 111,
    slug: '1233회-꿈-숫자-로또-활용법',
    title: '1233회 꿈 숫자 로또 활용법',
    keyword: '1233회 로또 꿈 숫자',
    excerpt: '꿈에서 본 숫자와 상징을 참고용 후보로 정리하고 자동번호와 결합해 1233회 조합을 만드는 방법입니다.',
    image: '{{image-111}}',
    imageAlt: '꿈 구름 속 숫자와 로또 공을 연결한 설명형 일러스트',
    sections: [
      ['꿈에서 본 숫자 기록하기', '꿈속에서 시계 시간, 버스 번호, 집 호수처럼 숫자를 직접 봤다면 깨자마자 장면과 함께 적어 두세요. 숫자가 1~45 안에 있으면 후보로 남기고, 범위를 넘으면 자릿수를 나누는 등 자신만의 단순한 규칙을 적용할 수 있습니다. 기억이 흐릿한 숫자를 억지로 만들기보다 또렷하게 남은 한두 개만 사용하는 편이 자연스럽습니다.'],
      ['꿈 상징을 숫자로 바꾸는 기준', '동물의 수, 계단 층수, 꽃의 개수처럼 셀 수 있는 요소가 있다면 그 값을 참고 숫자로 삼을 수 있습니다. 색이나 감정처럼 정답이 없는 상징은 자신에게 먼저 떠오른 숫자를 고르되 해석 기준을 기록해 두세요. 꿈해몽 숫자는 문화적 상징과 개인적 연상을 즐기는 방식이며 실제 당첨을 예측하거나 행운을 보장하는 정보가 아닙니다.'],
      ['꿈 숫자와 자동번호 결합하기', '꿈에서 얻은 숫자가 한두 개라면 해당 숫자를 고정하고 나머지를 무작위로 채우는 반자동 조합이 편합니다. 후보가 너무 많다면 기억이 선명한 순서대로 두세 개만 남기고 나머지는 제외하세요. 완성 후에는 1~45 범위와 중복을 확인하고, 마음에 드는 조합이 나올 때까지만 제한적으로 재생성해 선택 피로와 과도한 구매를 피합니다.']
    ],
    table: [['꿈 요소', '숫자 후보 예'], ['직접 본 숫자', '시간·호수·표지판'], ['개수를 센 사물', '꽃·계단·동물 수'], ['상징과 느낌', '개인 연상 숫자']],
    ordered: ['깨자마자 꿈 장면과 숫자를 기록합니다.', '가장 선명한 숫자 두세 개만 고릅니다.', '나머지는 자동 생성으로 중복 없이 채웁니다.'],
    bullets: ['꿈 숫자는 재미와 기록용입니다.', '해석 기준을 일관되게 유지합니다.', '당첨을 암시한다고 단정하지 않습니다.'],
    conclusion: '꿈 숫자를 활용하는 방법은 1233회 조합에 개인적인 이야기와 재미를 더해 줍니다. 직접 본 숫자나 셀 수 있는 상징을 우선 기록하고, 선명한 후보만 두세 개 남긴 뒤 나머지는 자동 생성으로 채워 보세요. 꿈해몽과 행운번호는 객관적인 예측 공식이 아니므로 결과를 보장하는 표현은 피해야 합니다. 기억을 즐겁게 정리하는 참고 방식으로 이용하고, 최종 구매는 생활에 부담 없는 범위에서 결정하세요.',
    faq: [['꿈에 나온 숫자는 당첨 신호인가요?', '그렇게 단정할 수 없습니다. 꿈 숫자는 개인적인 의미와 재미를 위한 참고 후보로 보는 것이 좋습니다.'], ['꿈 숫자가 45보다 크면 어떻게 하나요?', '자릿수를 나누거나 제외하는 등 간단한 개인 규칙을 정하되 결과를 억지로 맞추지는 마세요.']]
  }
];

function makeTable(rows) {
  const [head, ...body] = rows;
  return `<div class='table-responsive'><table><thead><tr>${head.map((cell) => `<th>${cell}</th>`).join('')}</tr></thead><tbody>${body.map((row) => `<tr>${row.map((cell) => `<td>${cell}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`;
}

function makeContent(topic) {
  const [first, second, third] = topic.sections;
  return `<article class='dream-article lotto-guide-article'>
<h2 id='intro'>${topic.title}</h2>
<p>${topic.excerpt} 당첨을 약속하는 숫자는 없지만, 기준을 정해 후보를 비교하면 선택 과정은 훨씬 간결해집니다. 아래 내용을 따라가며 나에게 맞는 1233회 조합을 차분히 구성해 보세요. 숫자를 고른 이유까지 짧게 기록하면 나중에 다른 후보와 비교할 때 판단 기준이 더욱 또렷해집니다.</p>
<h3 id='${topic.slug}-one'>${first[0]}</h3><p>${first[1]} 선택 기준은 메모해 두고 다른 조합에도 같은 방식으로 적용하면 비교 과정이 더 명확해집니다.</p>
<a class='lotto-explainer-link' href='/' aria-label='몽픽 메인으로 이동'><img src='${topic.image}' alt='${topic.imageAlt}' loading='lazy' width='800' height='450'/><span>이미지를 누르면 몽픽 메인으로 이동합니다.</span></a>
${makeTable(topic.table)}
<h3 id='${topic.slug}-two'>${second[0]}</h3><p>${second[1]} 선택 기준은 메모해 두고 다른 조합에도 같은 방식으로 적용하면 비교 과정이 더 명확해집니다.</p>
<ol>${topic.ordered.map((item) => `<li>${item}</li>`).join('')}</ol>
<div class='dream-cta-box'><p>지금 기준을 적용한 새 조합이 필요하다면 몽픽 로또 생성기를 이용해 보세요.</p><a class='dream-cta-button' href='/lotto'>1233회 번호 5게임 생성하기</a></div>
<h3 id='${topic.slug}-three'>${third[0]}</h3><p>${third[1]} 선택 기준은 메모해 두고 다른 조합에도 같은 방식으로 적용하면 비교 과정이 더 명확해집니다.</p>
<ul>${topic.bullets.map((item) => `<li>${item}</li>`).join('')}</ul>
<h3 id='qa'>1233회 로또 Q&amp;A</h3>
<h4>${topic.faq[0][0]}</h4><p>${topic.faq[0][1]}</p>
<h4>${topic.faq[1][0]}</h4><p>${topic.faq[1][1]}</p>
<h3 id='conclusion'>마치며</h3><p>${topic.conclusion}</p>
</article>`;
}

const posts = topics.map((topic) => {
  const canonicalUrl = `${siteUrl}/blog/${topic.slug}`;
  const faqEntities = topic.faq.map(([name, text]) => ({
    '@type': 'Question',
    name,
    acceptedAnswer: { '@type': 'Answer', text }
  }));

  return {
    id: `generated-${topic.slug}`,
    source: 'generated',
    keyword: topic.keyword,
    slug: topic.slug,
    title: topic.title,
    excerpt: topic.excerpt,
    content: makeContent(topic),
    imageAlt: topic.imageAlt,
    createdAt: publishedAt,
    updatedAt: publishedAt,
    publishedAt,
    date: publishedAt,
    category,
    tags: [category, topic.keyword, '로또 번호 만들기', '몽픽 로또'],
    canonicalUrl,
    toc: [
      { id: 'intro', label: '서론' },
      { id: `${topic.slug}-one`, label: topic.sections[0][0] },
      { id: `${topic.slug}-two`, label: topic.sections[1][0] },
      { id: `${topic.slug}-three`, label: topic.sections[2][0] },
      { id: 'qa', label: 'Q&A' },
      { id: 'conclusion', label: '마치며' }
    ],
    seo: {
      title: topic.title,
      description: topic.excerpt,
      canonicalUrl,
      ogTitle: topic.title,
      ogDescription: topic.excerpt
    },
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: topic.title,
      description: topic.excerpt,
      datePublished: publishedAt,
      dateModified: publishedAt,
      mainEntityOfPage: canonicalUrl,
      url: canonicalUrl,
      author: { '@type': 'Organization', name: '몽픽' },
      publisher: {
        '@type': 'Organization',
        name: '몽픽',
        logo: { '@type': 'ImageObject', url: `${siteUrl}/mongpick-logo-new.jpg` }
      }
    },
    faqLd: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqEntities
    }
  };
});

module.exports = posts;
